<script setup>
import {inject, onMounted, provide, ref} from "vue";
import useComment, {USE_COMMENT_KEY} from "./comments/CommentComposition";
import useNickname, {USE_NICKNAME_KEY} from "./comments/NicknameComposition";
import PostContainer from "./components/PostContainer.vue";
import CommentThreads from "./comments/CommentThreads.vue";
import DirectComment from "./comments/DirectComment.vue";
import {ClientJS} from "clientjs";

const siteUrl = document.querySelector('meta[name="site-url"]').content;

const commentComposition = useComment();
provide(USE_COMMENT_KEY, commentComposition);

const nicknameComposition = useNickname(siteUrl);
provide(USE_NICKNAME_KEY, nicknameComposition);

const postId = inject('postId');
const userId = inject('userId');

// 描画投稿データ
const post = ref(null);

// インラインデータがあれば同期初期化（ClientJS を実行しない・LCP ブロックなし）
const inlineData = window.__PLACE_DETAIL__ ?? null;
if (inlineData?.post) {
  post.value = inlineData.post;
  if (inlineData.empathy) {
    post.value.is_empathy = Boolean(inlineData.empathy.post);
  }
  commentComposition.initData(
    inlineData.comments,
    inlineData.commentViolations,
    userId,
    inlineData.post.id,
    inlineData.post.user_nickname_id,
    inlineData.isMyPost,
    Number(inlineData.post.accept_comments_type) !== 0,
    inlineData.draftComments
  );
  nicknameComposition.init(inlineData.nicknames ?? null);
}

onMounted(() => {
  if (inlineData?.post) {
    // インラインデータあり: 描画後に setTimeout で遅延させてコメント共感のみ取得
    // post.value.is_empathy は変更しない（PostContainer 再描画 → LCP 更新を防ぐ）
    setTimeout(() => {
      commentComposition.fetchEmpathy();
    }, 0);
    return;
  }

  // インラインデータなし: 従来通り全取得
  setTimeout(async () => {
    try {
      const response = await fetch(siteUrl+'place/get-post/'+postId+'?fingerprint='+(new ClientJS()).getFingerprint());
      const data = await response.json();
      post.value = data.post;
      if (data.empathy) {
        post.value.is_empathy = Boolean(data.empathy.post);
      }
      commentComposition.init(
        data.comments,
        data.commentViolations,
        userId,
        data.post.id,
        data.post.user_nickname_id,
        data.isMyPost,
        Number(data.post.accept_comments_type) !== 0,
        data.draftComments
      );
      nicknameComposition.init(data.nicknames ?? null);
    } catch (e) {
      console.error(e);
    }
  }, 0);
});
</script>

<template>
  <div>
    <PostContainer
      v-if="post !== null"
      container-type="detail"
      :login-user-id="userId"
      :post="post"
    />
    <teleport to="#js-post-comment">
      <DirectComment />
    </teleport>
    <teleport to="#js-comments">
      <CommentThreads />
    </teleport>
  </div>
</template>
